import { Check, ArrowDown } from "lucide-react";

const GetSavedSection = () => {
  return (
    <section className="py-24 bg-qcard-dark relative overflow-hidden">
      {/* Background gradient */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-[200px]" />
      
      <div className="container relative z-10 mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-green-500/20 text-green-400 text-sm font-semibold mb-4 border border-green-500/30">
            The Solution
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            Get Saved,{" "}
            <span className="text-primary">Not Thrown Away</span>
          </h2>
          <p className="text-lg text-white/50">
            QCard doesn't ask to be remembered — it makes sure you are.
          </p>
        </div>

        {/* Demo Visual */}
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Left - Explanation */}
            <div className="space-y-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary font-bold">1</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-2">They tap your QCard</h3>
                  <p className="text-white/60">
                    Share via NFC, QR code, or your personal link. Works with any smartphone — no app required.
                  </p>
                </div>
              </div>
              
              <div className="flex items-center justify-center md:justify-start pl-5">
                <ArrowDown className="w-6 h-6 text-primary/50" />
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary font-bold">2</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-2">One button saves everything</h3>
                  <p className="text-white/60">
                    Your name, face, title, phone, email, and socials — all saved to their contacts with a single tap.
                  </p>
                </div>
              </div>
              
              <div className="flex items-center justify-center md:justify-start pl-5">
                <ArrowDown className="w-6 h-6 text-primary/50" />
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-green-500/20 flex items-center justify-center flex-shrink-0">
                  <Check className="w-6 h-6 text-green-400" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-2">You're saved forever</h3>
                  <p className="text-white/60">
                    You're not a card in a stack. You're saved alongside their mother, their best friend, their boss.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Right - Phone Mockup with Real Profile */}
            <div className="relative flex justify-center">
              <div className="relative">
                {/* Phone Frame */}
                <div className="w-64 h-[500px] bg-slate-900 rounded-[2.5rem] p-2.5 shadow-2xl border border-white/10">
                  {/* Dynamic Island */}
                  <div className="absolute top-4 left-1/2 -translate-x-1/2 w-24 h-6 bg-black rounded-full z-20" />
                  
                  <div 
                    className="w-full h-full bg-slate-800 rounded-[2rem] overflow-hidden relative"
                    style={{ contain: 'strict' }}
                  >
                    {/* Real Profile Iframe - uses same pattern as InteractivePhoneMockup */}
                    <div 
                      className="absolute top-0 left-0"
                      style={{
                        width: '375px',
                        height: '7500px',
                        transform: 'scale(0.64)',
                        transformOrigin: 'top left',
                        willChange: 'transform',
                        WebkitFontSmoothing: 'antialiased',
                        contain: 'layout',
                        pointerEvents: 'none',
                      }}
                    >
                      <iframe
                        src="https://card.qcardenterprise.com/c/flower_gozum_1308244403"
                        title="QCard Profile - Insurance"
                        style={{
                          width: '375px',
                          height: '7500px',
                          maxWidth: '100%',
                          border: 'none',
                          pointerEvents: 'none',
                          display: 'block',
                          imageRendering: 'auto',
                          objectFit: 'contain',
                        }}
                        sandbox="allow-scripts allow-same-origin"
                        scrolling="no"
                        loading="eager"
                      />
                    </div>
                  </div>
                </div>
                
                {/* Glow */}
                <div className="absolute -inset-8 bg-primary/20 rounded-full blur-3xl -z-10" />
              </div>
            </div>
          </div>
        </div>

        {/* Bottom benefit */}
        <div className="mt-20 text-center">
          <div className="inline-flex items-center gap-4 px-8 py-4 rounded-2xl bg-green-500/10 border border-green-500/20">
            <Check className="w-6 h-6 text-green-400" />
            <p className="text-white">
              When they need what you offer, you're already there — 
              <span className="text-primary font-semibold"> a swipe away</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetSavedSection;
